const P = { fill: "none", stroke: "currentColor", "stroke-width": 2, "stroke-linecap": "round", "stroke-linejoin": "round", "aria-hidden": "true", focusable: "false" } as const;

export const MicIcon = () => (
  <svg viewBox="0 0 24 24" {...P}><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3M8 21h8" /></svg>
);
export const MicOffIcon = () => (
  <svg viewBox="0 0 24 24" {...P}><path d="M9 9v2a3 3 0 0 0 5.1 2.1M15 10V6a3 3 0 0 0-6 0M5 11a7 7 0 0 0 11 5.7M19 11a7 7 0 0 1-.9 3.4M12 18v3M8 21h8M3 3l18 18" /></svg>
);
export const EndIcon = () => (
  <svg viewBox="0 0 24 24" {...P}><path d="M3 12c5-5 13-5 18 0l-2.5 2.5-3-1.5v-2.5a9 9 0 0 0-7 0V13l-3 1.5z" /></svg>
);
export const CloseIcon = () => (
  <svg viewBox="0 0 24 24" {...P}><path d="M6 6l12 12M18 6L6 18" /></svg>
);
export const PlayIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z" /></svg>
);
export const SendIcon = () => (
  <svg viewBox="0 0 24 24" {...P}><path d="M22 2L11 13M22 2l-7 20-4-9-9-4z" /></svg>
);
export const ChatIcon = () => (
  <svg viewBox="0 0 24 24" {...P}><path d="M21 12a8 8 0 0 1-8 8H8l-5 3 1.5-4.5A8 8 0 1 1 21 12z" /></svg>
);
export const ExpandIcon = () => (
  <svg viewBox="0 0 24 24" {...P}><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" /></svg>
);
export const ShrinkIcon = () => (
  <svg viewBox="0 0 24 24" {...P}><path d="M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7" /></svg>
);
export const FullscreenIcon = () => (
  <svg viewBox="0 0 24 24" {...P}><path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5" /></svg>
);
